<template>
  <v-dialog v-model="visible" max-width="560" persistent class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-5">
        <div class="text-h5">
          <span style="color: #2655f1">驳回</span>
          <span>申请</span>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" :disabled="submitting" @click="onCancel" />
      </div>

      <v-card-text class="px-8 pt-0 pb-4">
        <div class="section-hint text-body-2 mb-4">
          请填写驳回原因，申请人将据此修改后重新提交。
        </div>
        <div class="section-title mb-2">驳回原因</div>
        <v-textarea v-model="reason" variant="outlined" density="compact" hide-details="auto" rows="4" auto-grow
          maxlength="500" counter class="gm-input" placeholder="请输入驳回原因" :error="showError"
          :error-messages="showError ? '请填写驳回原因' : ''" autofocus @update:model-value="showError = false" />
      </v-card-text>

      <v-card-actions class="px-8 pb-6 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-8 mr-3" :disabled="submitting"
          @click="onCancel">
          取消
        </v-btn>
        <v-btn color="#2655f1" variant="flat" class="gm-btn-primary text-white px-8" :loading="submitting"
          @click="onConfirm">
          确认驳回
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  submitting: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const reason = ref('')
const showError = ref(false)

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

watch(
  () => props.modelValue,
  (open) => {
    if (!open) return
    reason.value = ''
    showError.value = false
  },
)

function onCancel() {
  visible.value = false
}

function onConfirm() {
  const text = reason.value.trim()
  if (!text) {
    showError.value = true
    return
  }
  emit('confirm', text)
}
</script>

<style scoped lang="scss">
/* 与 system-manager/config/ProductModel/_dialog-styles.scss 一致的视觉规范 */

.gm-dialog {
  :deep(.v-overlay__content) {
    border-radius: 30px !important;
  }
}

.dialog-card {
  border-radius: 30px !important;
  background: #fff;
}

.gm-dialog-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  position: relative;

  .text-h5 {
    font-size: 22px !important;
    font-weight: 500;
  }
}

.section-hint {
  color: rgba(46, 46, 46, 0.6);
  line-height: 1.6;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.gm-input {
  :deep(.v-field) {
    background-color: rgba(239, 244, 251, 0.7) !important;
    border-radius: 12px !important;
    box-shadow: none !important;
    padding-inline: 4px !important;

    .v-field__outline {
      display: none !important;
    }
  }
}

.gm-btn-secondary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #545454 !important;
  box-shadow: none !important;
}

.gm-btn-primary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}
</style>
